const regionNames =
    typeof Intl !== "undefined" && Intl.DisplayNames
        ? new Intl.DisplayNames(["en"], { type: "region" })
        : null;

export const getCountryLabel = (countryCode) => {
    if (!countryCode) return "";
    try {
        return regionNames?.of(countryCode) || countryCode;
    } catch {
        return countryCode;
    }
};
